var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center h-full"},[_c('div',[_c('div',{staticClass:"text-xs h-40 flex justify-center items-center rounded-sm py-2 px-2 w-full"},[_c('neo-button',{attrs:{"text":"click to preview candiate form"},on:{"click":_vm.previewForm}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }